module.exports = __webpack_public_path__ + "img/htEvent_introduce_banner_tw.3b4a85a5.jpg";